<template>
	<v-btn
		icon
		size="small"
		variant="text"
		class="reset-size-button"
		@click="handleReset"
	>
		<v-icon icon="mdi-arrow-expand-all" size="small"></v-icon>
		<v-tooltip activator="parent" location="bottom">
			Reset modal size
		</v-tooltip>
	</v-btn>
</template>

<script>
export default {
	name: 'AResetSizeButton',
	emits: ['reset'],

	methods: {
		handleReset() {
			this.$emit('reset')
		}
	}
}
</script>

<style scoped lang="sass">
.reset-size-button
	margin-right: 8px
	opacity: 0.7
	transition: opacity 0.2s ease

	&:hover
		opacity: 1

	@media (max-width: 768px)
		display: none !important
</style>

